import { extractWorkout as _extractWorkout, planHistory as _planHistory } from '@fitflex/shared';
import type { ParsedSource, TabRole, ExtractedSession, HistoryPlan } from '@fitflex/shared';

/* History extraction lives in @fitflex/shared (shared with mobile). Only the id
   generator differs per platform, so this thin wrapper injects web's crypto and
   preserves the original call signatures so consumers are unchanged. */

const rid = (): string => crypto.randomUUID();

export const extractWorkout = (src: ParsedSource): ExtractedSession | null => _extractWorkout(src, rid);
export const planHistory = (sources: ParsedSource[], aiRoles: Record<number, TabRole> = {}): HistoryPlan =>
  _planHistory(sources, aiRoles, rid);

export { classifyTab, extractCheckIns, extractDietNote } from '@fitflex/shared';
export type { TabRole, ExtractedSession, ExtractedCheckIn, HistoryPlan } from '@fitflex/shared';
